import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import * as api from '../api/api';
import { pickErrorMessage } from '../lib/apiHelpers';
import { BrandLogo } from '../components/BrandLogo';
import { branding } from '../config/branding';
import { ErrorBanner } from '../components/PageChrome';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const tokenFromUrl = params.get('token') || '';

  const [token, setToken] = useState(tokenFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.resetPassword({ token: token.trim(), newPassword });
      setDone(true);
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
      <div className="card shadow border-0" style={{ maxWidth: 480, width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <div className="d-flex align-items-center gap-2 mb-4">
            <BrandLogo />
            <div>
              <h1 className="h5 mb-0">Set new password</h1>
              <p className="text-secondary small mb-0">{branding.productName}</p>
            </div>
          </div>
          {done ? (
            <>
              <p className="text-secondary mb-3">Your password has been reset. You can sign in now.</p>
              <Link to="/login" className="btn btn-primary w-100">Go to sign in</Link>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              <ErrorBanner message={error} />
              <div className="mb-3">
                <label htmlFor="token" className="form-label">Reset token</label>
                <input id="token" className="form-control" value={token} onChange={(e) => setToken(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">New password</label>
                <input id="newPassword" type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} minLength={8} required />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={busy}>
                {busy ? 'Saving…' : 'Reset password'}
              </button>
            </form>
          )}
          <div className="text-center mt-3">
            <Link to="/login" className="small">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
